import {
  ERROR_ACTION,
  SET_GET_ACTIVE_USER,
  SET_GET_APPROVAL_USER,
  SET_ROLE_BY_DEPT,
  SET_SUPERVISOR_BY_ROLE,
  SET_CHANGE_PWD_MODAL,
} from "../../common/constants/ActionTypes";

const initialState = {
  errorMessage: "",
  showLoader: false,
  getActiveUser: [],
  roleByDept: [],
  supervisorByRole: [],
  getApprovalUser: [],
  showChangePwdModal: false,
};

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_GET_ACTIVE_USER:
      return {
        ...state,
        getActiveUser: action.payload,
      };
    case SET_GET_APPROVAL_USER:
      return {
        ...state,
        getApprovalUser: action.payload,
      };
    case SET_ROLE_BY_DEPT:
      return {
        ...state,
        roleByDept: action.payload,
      };
    case SET_SUPERVISOR_BY_ROLE:
      return {
        ...state,
        supervisorByRole: action.payload,
      };
    case SET_CHANGE_PWD_MODAL:
      return {
        ...state,
        showChangePwdModal: action.payload,
      };

    default:
      return state;
  }
}
